module.exports = "/_next/static/images/80ddcdec600c7dde2c8c981d47e2ee66-credit-zero-rate.svg.webp";